import React from 'react';
import AddprojectForm from '../components/dashboard/AddprojectForm';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import ModalMenu from '../components/Modal/ModalMenu';
import ModalSearch from '../components/Modal/ModalSearch';
import Scrollup from '../components/Scrollup/Scrollup';



const Addproject = () => {

   

    
        return (

            <div className="main">
                <Header />
               <AddprojectForm/>
                <Footer/>
                <ModalSearch />
                <ModalMenu />
                <Scrollup />
            </div>

            
        );
    }


export default Addproject;